import { Blockquote, Amazon, Vocabulary, SoThisIsChristmasIndex, AffiliateBanner } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Vocabulary,
  SoThisIsChristmasIndex,
  AffiliateBanner,
  React
};